import { Animated, View, Image } from 'react-native';
import React, { useEffect, useRef } from 'react';
import { Text } from '~/components';
import { SUCCESS_PAGE_WIDTH } from '../../index.web';
import type { WebListPage } from '../../types';

const Page = ({ image, text, footer }: WebListPage) => {
  const imageBounce = useRef(new Animated.Value(-10));

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(imageBounce.current, {
          toValue: 10,
          duration: 1000,
          useNativeDriver: false,
        }),
        Animated.timing(imageBounce.current, {
          toValue: -10,
          duration: 1000,
          useNativeDriver: false,
        }),
      ]),
      {
        iterations: -1,
      }
    ).start();
  }, [imageBounce]);

  return (
    <View
      className={'items-center mt-8 lg:mt-0'}
      style={{ width: SUCCESS_PAGE_WIDTH }}
    >
      <View className="w-[200px] h-[260px]">
        <Animated.View
          className={'absolute'}
          style={{ top: imageBounce.current }}
        >
          <Image
            className="h-[250px] w-[200px]"
            resizeMode={'contain'}
            source={image}
          />
        </Animated.View>
      </View>

      <View className="items-center mt-12">
        <Text className="text-center text-xl max-w-[250px]">{text}</Text>
      </View>

      <View className="justify-end flex-1 w-[328px]">{footer}</View>
    </View>
  );
};

export default Page;
